// extracted by mini-css-extract-plugin
export default {"countContainer":"styles_countContainer__3lqSM"};